// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const darmanitan_galar_standard: PokeData = {
  "id": 10177,
  "name": "darmanitan-galar-standard",
  "height": 17,
  "weight": 1200,
  "base_experience": 168,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "ice-punch",
    "headbutt",
    "tackle",
    "thrash",
    "bite",
    "blizzard",
    "powder-snow",
    "belly-drum",
    "uproar",
    "taunt",
    "superpower",
    "avalanche",
    "ice-fang",
    "work-up",
    "icicle-crash"
  ],
  "moves": [
    "ice-punch",
    "headbutt",
    "tackle",
    "bite",
    "blizzard",
    "superpower",
    "avalanche",
    "ice-fang",
    "sheer-cold",
    "aurora-veil",
    "hailstorm",
    "ice-wave",
    "ice-shard"
  ],
  "evolution_chain": {
    "id": 282,
    "item": null,
    "species": [
      {
        "name": "darumaka",
        "order": 555,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "darmanitan",
        "order": 556,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 554,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 121,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
